import { useState } from 'react'
import styled from 'styled-components'

import { Nullable } from 'shared/utils/type-guards'

import { CardBody, CardHeader } from '~/views/components/elements/overview'
import ExperienceOverview from '~/views/components/Overview/ExperienceOverview'
import Pagination from '~/views/components/Pagination'
import Card from '~/views/components/ui/Card'
import Text from '~/views/components/ui/Text'
import { useStaticLabels } from 'shared/hooks/use-static-labels'

const OverviewBody = styled(CardBody)`
  display: grid;
  grid-template-rows: 1fr 30px;
  justify-items: center;
  grid-gap: 10px;
`

export interface Props {
  className?: string
  templates?: Nullable<
    {
      id: string
      videoUrl?: Nullable<string>
      videoPlaceholderImage?: Nullable<{ originalUrl?: Nullable<string> }>
      experienceOverview?: Nullable<string>
    }[]
  >
  project?: {
    id?: string
    projectManager?: Nullable<{ id: string }>
  }
  organization?: Nullable<{
    id: string
    name?: Nullable<string>
    logo?: Nullable<{ originalUrl?: Nullable<string> }>
  }>
}

const ExperienceOverviewCard = ({
  project,
  templates: passedTemplates = [],
  organization,
  className,
}: Props) => {
  const [getCommonLabel] = useStaticLabels(['common'])
  const [selectedTemplateIndex, setSelectedTemplateIndex] = useState(0)

  const templates = passedTemplates || []
  const templateCount = templates.length

  const hasAnyTemplates = templateCount > 0
  const hasMultipleTemplates = templateCount > 1
  const selectedTemplate =
    hasAnyTemplates && !!templates[selectedTemplateIndex]
      ? templates[selectedTemplateIndex]
      : null

  return (
    <Card className={className}>
      <CardHeader>
        <Text size="large" weight="bold">
          {getCommonLabel('experienceOverview')}
        </Text>
      </CardHeader>

      <OverviewBody>
        {selectedTemplate && (
          <div
            style={{
              height: '100%',
              width: '100%',
              maxHeight: '285px',
              overflowY: 'scroll',
            }}
          >
            <ExperienceOverview
              key={selectedTemplate.id}
              projectManager={project?.projectManager}
              videoUrl={selectedTemplate?.videoUrl}
              imageUrl={selectedTemplate?.videoPlaceholderImage?.originalUrl}
              experienceOverview={selectedTemplate?.experienceOverview}
              overviewType="project"
              organization={organization}
              projectId={project?.id || ''}
            />
          </div>
        )}

        {hasMultipleTemplates && (
          <Pagination
            dots={templateCount}
            index={selectedTemplateIndex}
            onChangeIndex={(newIndex) => {
              if (
                newIndex >= 0 &&
                newIndex < templateCount &&
                newIndex !== selectedTemplateIndex
              ) {
                setSelectedTemplateIndex(newIndex)
              }
            }}
          />
        )}
      </OverviewBody>
    </Card>
  )
}

export default ExperienceOverviewCard
